module.exports = __webpack_public_path__ + "static/incomparable-results-a27a82b0689ee3b4c3033e7154499c2f.svg";